/* eslint "react/no-children-prop": "off" */

'use client';

import { bigTitleSection } from '@stereoagency/sanity-schema';
import { BigTitleSection as UIBigTitleSection } from '@stereoagency/ui';
import { BlockContent } from '../sanity/client';
import { sanityImageAsProps } from '@/utils';

type Props = typeof bigTitleSection.schema.bigTitleSection;

export default function BigTitleSection({
  title,
  variant,
  primaryContent,
  secondaryContent,
  image
}: Props) {
  const imageProps = image ? sanityImageAsProps(image) : null;

  if (!title) {
    return null;
  }

  return (
    <UIBigTitleSection
      title={title}
      variant={variant}
      image={imageProps ?? undefined}
      children={
        variant === 'columns' ? (
          [
            <BlockContent key="column-1" value={primaryContent ?? []} />,
            <BlockContent key="column-2" value={secondaryContent ?? []} />
          ]
        ) : (
          <BlockContent value={primaryContent ?? []} />
        )
      }
    />
  );
}
